var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',[_c('a',{attrs:{"target":"_blank"}},[_vm._v("پنل فروشگاهی ")]),_c('span',{staticClass:"ml-1 panel-version",attrs:{"title":_vm.build}},[_vm._v("نسخه "+_vm._s(_vm.version))])])])}
var staticRenderFns = []

export { render, staticRenderFns }